/* © ИП Коробкин И.Н., KIN DIGITAL CRM+ */
import { useQuery } from '@tanstack/react-query';
import { useEffect } from 'react';
import { api } from '@/lib/api';

export interface Branding { name: string; shortName: string; color: string; logo: string | null; portalTitle: string; appName: string }
export const DEFAULT_BRANDING: Branding = { name: 'KIN DIGITAL CRM+', shortName: 'KIN DIGITAL', color: '#0f6b5d', logo: null, portalTitle: 'Личный кабинет клиента', appName: 'Мобильный Юрист' };

const hex = (h: string) => [1, 3, 5].map((i) => parseInt(h.slice(i, i + 2), 16));
const mix = (a: number[], b: number[], t: number) => a.map((x, i) => Math.round(x + (b[i] - x) * t));

/** Палитра 50-900 из одного фирменного цвета (цвет = оттенок 600) */
export function palette(color: string): Record<number, number[]> {
  const c = hex(/^#[0-9a-f]{6}$/i.test(color) ? color : DEFAULT_BRANDING.color);
  const W = [255, 255, 255]; const B = [0, 0, 0];
  return { 50: mix(c, W, 0.93), 100: mix(c, W, 0.84), 200: mix(c, W, 0.68), 300: mix(c, W, 0.5), 400: mix(c, W, 0.25), 500: mix(c, W, 0.1), 600: c, 700: mix(c, B, 0.2), 800: mix(c, B, 0.36), 900: mix(c, B, 0.52) };
}

export function applyBranding(b: Branding) {
  const root = document.documentElement;
  for (const [k, v] of Object.entries(palette(b.color))) root.style.setProperty(`--brand-${k}`, v.join(' '));
  const meta = document.querySelector('meta[name="theme-color"]');
  if (meta) meta.setAttribute('content', b.color);
}

export function useBranding() {
  const { data } = useQuery({ queryKey: ['branding'], queryFn: () => api.get<Branding>('/public/branding'), staleTime: 5 * 60_000 });
  const b = data ?? DEFAULT_BRANDING;
  useEffect(() => { if (data) applyBranding(data); }, [data]);
  return b;
}
